import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=4d5271f0&"
import script from "./ReportsList.vue?vue&type=script&lang=js&"
export * from "./ReportsList.vue?vue&type=script&lang=js&"
import style0 from "./ReportsList.vue?vue&type=style&index=0&id=4d5271f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports